module.exports = __webpack_public_path__ + "img/no-tasks.90259537.svg";